import { makeStyles } from '@material-ui/core'

export const PREVIEW_HEIGHT = 350

const useStyles = makeStyles((theme) => ({
  previewWrapper: {
    position: 'relative',
    width: '100%',
    height: PREVIEW_HEIGHT,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    pointerEvents: 'none',
  },
  previewIframe: {
    border: 'none',
    transformOrigin: 'top left',
    display: 'block',
  },
  previewPlaceholder: {
    width: '100%',
    height: PREVIEW_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
  },
}))

export default useStyles
